import React, {FC} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {isUhcEnabled} from 'libs/rollout';

import {StockNotification} from './components/stockNotification/stockNotification';
import {UhcNotification} from './components/uhcNotification/uhcNotification';

import s from './notificationBlock.scss';

export type PropsType = {
    item: QuoteItemV2;
    productHasNotification?: boolean;
};
/**
 * Notification Block for the product on cart page
 */
export const NotificationBlock: FC<PropsType> = ({item, productHasNotification}) => {
    if (!productHasNotification && !isUhcEnabled()) return null;

    return (
        <div aria-label="notification block" className={s.notificationBlock}>
            {isUhcEnabled() && <UhcNotification item={item} />}
            {productHasNotification && <StockNotification item={item} />}
        </div>
    );
};
